import { DictionaryType, IDictionaryValue } from '@common/dictionaries';
import { ObjectValues } from '@common/utils-types';

/** Типы справочников (enum like) используемые в модуле базовые данные в проекте */
export const PROJECT_BASIC_DATA_DICTIONARY_TYPE = {
  categoryChoices: 'category_choices',
  currencyMultiplication: 'currency_multiplication',
  financingType: 'financing_type',
  timeDetalizations: 'time_detalizations',
  organizationForms: 'organization_forms',
} as const;

export type ProjectBasicDataDictionaryType = ObjectValues<typeof PROJECT_BASIC_DATA_DICTIONARY_TYPE>;

export class ProjectBasicDataDictionary extends DictionaryType {
  constructor(code: string, values: IDictionaryValue[]) {
    super(code, values);
  }
}
